import { render, staticRenderFns } from "./bukureklasbc.vue?vue&type=template&id=e01345e2"
import script from "./bukureklasbc.vue?vue&type=script&lang=js"
export * from "./bukureklasbc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports